  import baharPic from "../Assets/baharkhan.png";

  export const profile = {
    name: "Bahar Khan",
    titles: ["Flutter Developer"],
    bio: [
      "Proficient and detail-oriented Flutter developer skilled in building responsive, scalable, and visually appealing mobile applications using Dart and modern frameworks. Committed to leveraging cutting-edge technologies and best practices to deliver seamless cross-platform solutions with exceptional user experiences. I learn every day, and if given the opportunity to learn, I can even climb mountains.",
    ],
    image: baharPic,
    social: {
      email: "baharkhan.dev@gmail.com",
      linkedin: "https://www.linkedin.com/in/baharkhan/",
      github: "https://github.com/baharkhandev",
      x: "https://x.com/baharkhanbd",
    },
  };
